// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Csbr","modalForm":"UpgradeEpcsModal_modalForm__12AqM","modalFooter":"UpgradeEpcsModal_modalFooter__17nK1"};